var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderOff = function SvgFolderOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "folder_off_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#folder_off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.775 18.95 20 17.175V8h-9.15l-4-4h2.025a1.98 1.98 0 0 1 1.4.575L11.7 6H20q.824 0 1.413.587Q22 7.175 22 8v10q0 .275-.05.512a1.3 1.3 0 0 1-.175.438M4 20q-.824 0-1.412-.588A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.413A1.93 1.93 0 0 1 4 4l2 2H4v12h11.175L1.4 4.2a.98.98 0 0 1-.287-.688A.93.93 0 0 1 1.4 2.8a.95.95 0 0 1 .7-.275q.425 0 .7.275l18.4 18.4q.3.3.288.7t-.313.7q-.3.276-.7.287a.92.92 0 0 1-.7-.287l-2.6-2.6z"
  }))));
};
export default SvgFolderOff;